module.exports = __webpack_public_path__ + "static/media/app_settings.1f7fb873.png";